import React from "react";
import SideListView from "../Util/SideListView/SideListView";
import NavItem from "../Util/SideListView/NavItem";
import { IoCloudUpload } from "react-icons/io5";
import { MdMiscellaneousServices } from "react-icons/md";
import { IoDownload } from "react-icons/io5";
import { FaUsers } from "react-icons/fa";

// The Operations navigation. Each link: see NavItem (RCMC-04/-09, ticket 11)
const OperationSideListView = () => {
  return (
    <SideListView>
      <NavItem to="/operations/update-master-data" icon={IoCloudUpload} label="Update Master Data" />
      <NavItem to="/operations/service-request" icon={MdMiscellaneousServices} label="Service Requests" />
      <NavItem to="/operations/download-forms" icon={IoDownload} label="Forms & FAQs" />
      <NavItem to="/operations/user-management" icon={FaUsers} label="Users" />
    </SideListView>
  );
};

export default OperationSideListView;
